import { render, staticRenderFns } from "./MonitoringAdmin.vue?vue&type=template&id=b3e5f970&"
import script from "./MonitoringAdmin.vue?vue&type=script&lang=js&"
export * from "./MonitoringAdmin.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringAdmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports